module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-36.c7365103.svg";